import { createApiAction } from '@app/packages/api/utils'
import type { ApiAffiliate } from '@app/packages/api/v2/types/entities'

export const getAffiliates = () =>
  createApiAction('getAffiliates', dispatch => dispatch<{ data: ApiAffiliate[] }>({ method: 'GET', endpoint: '/api/v2/affiliates' }))
